import { Query } from 'graphql/generated/graphqlTypes';
import { mockDoors } from 'mocks/graphqlMocks/doorFixtures';

export function mockedGetDoorsWithoutNestedResolversData(
  getDoorsForTenant: Query['getDoorsForTenant']
): Pick<Query, 'getDoorsForTenant'> {
  return { getDoorsForTenant };
}

export const mockedGetDoorsWithoutNestedResolversDataForQuery = mockedGetDoorsWithoutNestedResolversData(mockDoors);
